export const pressRelease = {
    // keep the span and its text in the same line, otherwise, it would add an extra space
    firstTextBlockString: `
        <h3 style="text-align: center;">
            <span style="color: rgb(138, 139, 141);">FOR IMMEDIATE RELEASE</span>
        </h3>
    `,
    secondTextBlockString: `
        <h1 style="text-align: left;">
            <span style="color: rgb(0, 0, 0);">
                Get Journalists To Open, Click, And Love Your Email Pitch
            </span>
        </h1>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h2 style="text-align: left;">
            <span style="color: rgb(0, 0, 0);">
                Maximize open, click, and email engagement rates with our guide, featuring tips from PR pros.
            </span>
        </h2>
        <p style="text-align: center; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            We've analyzed emails sent through our integrated media database and outreach platform to learn the secrets of great pitching.
            After a long hard look at the numbers, we found the distributions that had performed exceptionally—with open and clickthrough
            rates that would be the envy of any PR pro—and put them under a microscope.
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h3 style="line-height: 200%;">
            <span>
                We looked for meaningful, implementable patterns, such as:
            </span>
        </h3>
        <ul style="letter-spacing: normal; margin-block: 0px; margin: 0px; list-style: inside;">
            <li>
                Length and type of subject line
            </li>
            <li>
                Best time and day to send
            </li>
            <li>
                Personalized copy or copy-and-paste press release
            </li>
            <li>
                And much more!
            </li>
        </ul>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            Plus, inside you’ll find pitching insights from the three PR pros whose emails earned top
            open rates and clickthrough rates!
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            By the time you’re done reading, you should have the knowledge you need to stand out from the crowd and get your emails opened
            and engaged with by journalists.
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <a href="https://www.agilitypr.com/love-your-email-pitch/" target="_blank" style="color: rgb(0, 0, 0);">
                Download your guide here
            </a>
        </p>
    `,
    thirdTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 200%">
            <strong>
                <span>
                    About Us
                </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <span style="color: rgb(0, 0, 0);">
                Agility PR Solutions helps PR pros generate and monitor media coverage, measure results, and demonstrate their value.
                We love helping them get their stories out and seeing them use our data to evolve and improve.
                Serving our clients is our reason for getting up in the morning, and we’re honored that they rank us #1 for
            </span>
            <em style="color: rgb(0, 0, 0);">
                customer support
            </em>
            <span style="color: rgb(0, 0, 0);">
                 and
            </span>
            <em style="color: rgb(0, 0, 0);">
                ease of doing business with
            </em>
            <span style="color: rgb(0, 0, 0);">
                .*
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <span style="color: rgb(142, 142, 142);">
                *Reported by G2 Crowd, Fall 2020
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 200%">
            <strong>
            <span>
                Contact Us
            </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <a href="https://www.agilitypr.com/contact/" target="_blank" style="color: rgb(0, 82, 204);">
                https://www.agilitypr.com/contact/
            </a>
        </p>
    `
};

export const minimalistDistribution = {
    firstTextBlockString: `
        <h1 style="text-align: center; style="line-height: 200%">
            <span style="color: rgb(41, 41, 41); font-size: 3rem; font-family: 'Times New Roman', Times, serif;">
                <span>
                    Get Attention With Your Headline.
                </span>
            </span>
        </h1>
    `,
    secondTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 200%">
            <span style="font-family: 'Times New Roman', Times, serif; font-size: 1rem;">
                <span>
                    You don’t need to have a snazzy opening, you can just send your release and let it speak for itself—but don’t send it to just anyone.
                    Make sure you’re targeting the right journalists and influencers. Worry less about word count and more about providing the essential
                    information needed to write a story. Attach a press release, at least one external link to more information or digital assets,
                    and provide journalists with all the information they could possibly want or need to produce an interesting and engaging piece.
                </span>
            </span>
        </p>
    `
};

export const marketingDistribution = {
    firstTextBlockString: `
        <p style="text-align: center; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h1 style="text-align: center;">
            <span style="font-size: 2.25rem; color: rgb(255, 81, 38);">
                Introducing: Agility Distributions!
            </span>
        </h1>
    `,
    secondTextBlockString: `
        <h2 style="text-align: center;">
            <span style="color: rgb(88, 89, 91);">
                Craft compelling copy and customize clever corporate communications
            </span>
        </h2>
    `,
    thirdTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <strong style="color: rgb(0, 0, 0); font-size: 1rem;">
                <em>
                    <span>
                        Introduction -
                    </span>
                </em>
            </strong>
            <em style="color: rgb(0, 0, 0); font-size: 1rem;">
                <span>
                    Introduce readers to your story. You can use as many or as few words as you would like, or paint a picture with images.
                    What do you want to share with the world today?
                </span>
            </em>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
    `,
    fourthTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <strong style="font-size: 1rem; color: rgb(38, 38, 38);">
                <span>
                    Conclusion -
                </span>
            </strong>
            <span style="font-size: 1rem; color: rgb(38, 38, 38);">
                <span>
                    Wrap it up and tie a bow in the conclusion. This is your chance to land the message and leave on a high note.
                    What do you want your audience to remember at the end of the day?
                </span>
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
    `,
    fifthTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 250%">
            <strong style="color: rgb(38, 38, 38); font-size: 1rem;">
                <span>
                    Who We Are
                </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <span style="color: rgb(38, 38, 38); font-size: 1rem;">
                <span>
                    Tell your company's story. When were you founded? What are you known for? Who should your audience identify as
                    associated with the organization? What's new and noteworthy?
                </span>
            </span>
        </p>
    `,
};

export const newBrandingPressRelease = {
    // keep the span and its text in the same line, otherwise, it would add an extra space
    firstTextBlockString: `
        <h3 style="text-align: center;">
            <span style="color: rgb(138, 139, 141);">FOR IMMEDIATE RELEASE</span>
        </h3>
    `,
    secondTextBlockString: `
        <h1 style="text-align: left;">
            <span style="color: rgb(30, 30, 30);">
                Get Journalists To Open, Click, And Love Your Email Pitch
            </span>
        </h1>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h2 style="text-align: left;">
            <span style="color: rgb(30, 30, 30);">
                Maximize open, click, and email engagement rates with our guide, featuring tips from PR pros.
            </span>
        </h2>
        <p style="text-align: center; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            We've analyzed emails sent through our integrated media database and outreach platform to learn the secrets of great pitching.
            After a long hard look at the numbers, we found the distributions that had performed exceptionally—with open and clickthrough
            rates that would be the envy of any PR pro—and put them under a microscope.
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h3 style="line-height: 200%">
            <span>
                We looked for meaningful, implementable patterns, such as:
            </span>
        </h3>
        <ul style="letter-spacing: normal; margin-block: 0px; margin: 0px; list-style: inside;">
            <li>
                Length and type of subject line
            </li>
            <li>
                Best time and day to send
            </li>
            <li>
                Personalized copy or copy-and-paste press release
            </li>
            <li>
                And much more!
            </li>
        </ul>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            Plus, inside you’ll find pitching insights from the three PR pros whose emails earned top
            open rates and clickthrough rates!
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            By the time you’re done reading, you should have the knowledge you need to stand out from the crowd and get your emails opened
            and engaged with by journalists.
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="text-align: left; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <a href="https://www.agilitypr.com/love-your-email-pitch/" target="_blank" style="color: rgb(0, 0, 0);">
                Download your guide here
            </a>
        </p>
    `,
    thirdTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 200%">
            <strong>
                <span>
                    About Us
                </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <span style="color: rgb(30, 30, 30);">
                Agility PR Solutions helps PR pros generate and monitor media coverage, measure results, and demonstrate their value.
                We love helping them get their stories out and seeing them use our data to evolve and improve.
                Serving our clients is our reason for getting up in the morning, and we’re honored that they rank us #1 for
            </span>
            <em style="color: rgb(30, 30, 30);">
                customer support
            </em>
            <span style="color: rgb(30, 30, 30);">
                 and
            </span>
            <em style="color: rgb(30, 30, 30);">
                ease of doing business with
            </em>
            <span style="color: rgb(30, 30, 30);">
                .*
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <span style="color: rgb(142, 142, 142);">
                *Reported by G2 Crowd, Fall 2020
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 200%">
            <strong>
                <span>
                    Contact Us
                </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; margin-bottom: 5px;">
            <a href="https://www.agilitypr.com/contact/" target="_blank" style="color: rgb(0, 82, 204);">
                https://www.agilitypr.com/contact/
            </a>
        </p>
    `
};

export const newBrandingMarketingDistribution = {
    firstTextBlockString: `
        <p style="text-align: center; letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <h1 style="text-align: center;">
            <span style="font-size: 2.25rem; color: rgb(35, 31, 68);">
                Introducing: Agility Distributions!
            </span>
        </h1>
    `,
    secondTextBlockString: `
        <h2 style="text-align: center;">
            <span style="color: rgb(88, 89, 91);">
                Craft compelling copy and customize clever corporate communications
            </span>
        </h2>
    `,
    thirdTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <strong style="color: rgb(30, 30, 30); font-size: 1rem;">
            <em>
                <span>
                    Introduction -
                </span>
            </em>
            </strong>
            <em style="color: rgb(30, 30, 30); font-size: 1rem;">
                <span>
                    Introduce readers to your story. You can use as many or as few words as you would like, or paint a picture with images.
                    What do you want to share with the world today?
                </span>
            </em>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
    `,
    fourthTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <strong style="font-size: 1rem; color: rgb(30, 30, 30);">
                <span>
                    Conclusion -
                </span>
            </strong>
            <span style="font-size: 1rem; color: rgb(30, 30, 30);">
                <span>
                    Wrap it up and tie a bow in the conclusion. This is your chance to land the message and leave on a high note.
                    What do you want your audience to remember at the end of the day?
                </span>
            </span>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
    `,
    fifthTextBlockString: `
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px;">
            <br>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 250%">
            <strong style="color: rgb(30, 30, 30); font-size: 1rem;">
                <span>
                    Who We Are
                </span>
            </strong>
        </p>
        <p style="letter-spacing: normal; margin-block: 0px; margin: 0px; line-height: 150%">
            <span style="color: rgb(30, 30, 30); font-size: 1rem;">
                <span>
                    Tell your company's story. When were you founded? What are you known for? Who should your audience identify as
                    associated with the organization? What's new and noteworthy?
                </span>
            </span>
        </p>
    `,
};


export const aiElement = {
    forImmediateReleaseText: `
        <h3 style="text-align: center;">FOR IMMEDIATE RELEASE</h3>
    `,
    pressReleaseForImmediateReleaseText: `
        <h3 style="text-align: center;">
            <span style="color: rgb(138, 139, 141);">FOR IMMEDIATE RELEASE</span>
        </h3>
    `,
    marketingForImmediateReleaseText: `
        <h3 style="text-align: center;">FOR IMMEDIATE RELEASE</h3>
    `,
    headline: `
        <h1>{{aiContent}}</h1>
    `,
    marketingHeadline:`
        <br>
        <h1 style="text-align: center;">
            <span style="color: rgb(255, 81, 38); font-size: 2.25rem;">{{aiContent}}</span>
        </h1>
    `,
    marketingEmailHeadline:`
        <br>
        <h1 style="text-align: center;">
            <span style="color: rgb(255, 81, 38); font-size: 3rem;">{{aiContent}}</span>
        </h1>
    `,
    minimalistHeadline: `
        <h1 style="text-align: center;">{{aiContent}}</h1>
    `,
    minimalistEmailHeadline: `
        <h1 style="text-align: center;">
            <span style="font-size: 3rem;">
                {{aiContent}}
            </span>
        </h1>
    `,
    subHeadline: `
        <h2>{{aiContent}}</h2>
    `,
    marketingSubHeadline: `
        <h2 style="text-align: center;">
            <span style="color: rgb(88, 89, 91);">{{aiContent}}</span>
        </h2>
    `,
    marketingPitch: `
        <p style="text-align: center;">
            <em>{{aiContent}}</em>
        </p>
    `,
    marketingConclusion: `
        <br>
        <p style="text-align: center;">
            {{aiContent}}
        </p>
    `,
    body: `
        {{aiContent}}
    `,
    aboutUs: `
        <h3>About Us</h3>
        {{aiContent}}
    `,
    marketingAboutUs: `
        <br>
        <p>
            <strong style="font-size: 1rem; color: rgb(38, 38, 38);">Who We Are</strong>
        </p>
        <p>{{aiContent}}</p>
    `,
    contactUs: `
        <h3>Contact Us</h3>
        {{aiContent}}
    `,
    marketingContactUs: `
        <br>
        <p>
            <strong style="color: rgb(38, 38, 38); font-size: 1rem;">How to Contact Us</strong>
        </p>
        <p>{{aiContent}}</p>
    `,
};
